// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__1BDBA","content":"ManualTimeModal_content__3LbKR"};